import type { BooksProductScope } from '@/features/book-management/domain'
import type { NetExposureEvent, NetExposureMarket } from './fixture'

/** Premium BM = artemis (and Lab name heuristics). */
export function isPremiumBmMarket(market: Pick<NetExposureMarket, 'marketName' | 'productType'>): boolean {
  const product = (market.productType || '').toLowerCase()
  if (product === 'artemis') return true
  const name = market.marketName.toLowerCase()
  return name.includes('premium') || name.includes('artemis')
}

function filterMarkets(
  markets: NetExposureMarket[],
  scope: BooksProductScope,
): NetExposureMarket[] {
  return markets.filter((m) => {
    const premium = isPremiumBmMarket(m)
    return scope === 'premium-bm' ? premium : !premium
  })
}

/** Split Book Management vs Premium BM Net Exposure from the shared books feed. */
export function filterEventsByProductScope(
  events: NetExposureEvent[],
  scope: BooksProductScope,
): NetExposureEvent[] {
  return events.flatMap((event) => {
    const matchOdds =
      event.matchOdds &&
      (scope === 'premium-bm'
        ? isPremiumBmMarket(event.matchOdds)
        : !isPremiumBmMarket(event.matchOdds))
        ? event.matchOdds
        : undefined
    const data = filterMarkets(event.data, scope)
    if (!matchOdds && data.length === 0) return []
    return [{ ...event, matchOdds, data }]
  })
}
